module.exports = __webpack_public_path__ + "img/map.c3883de4.jpg";